module.exports = __webpack_public_path__ + "img/trois-battants.c692d07.svg";